import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import SitemarkIcon from './SitemarkIcon';
import Grid from '@mui/material/Grid2';
import { fetchArticles, env } from '../../../services/AppService';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none', // Ensure no underline
        },
        underlineNone: {
          textDecoration: 'none', // Ensure no underline even when prop is 'none'
        },
      },
    },
  },
});


const freebsdImg = 'freebsd-power-button.gif'

// For displaying stylized quotes.
function Quote() {
	return (
		<React.Fragment>
		<Typography variant='caption' align='left' sx={{ fontStyle: 'italic', color: 'text.secondary', mt:1 }}>
			"If you don't know, the thing to do is not to get scared, but to 
			learn."
		</Typography>
		</React.Fragment>
	);
}

// Display the copyright of this website.
function Copyright() {
	return (
		<React.Fragment>
		<Typography variant="body2" align='left' sx={{ color: 'text.secondary', mt: 1 }}>
		  {'Hosted and Developed by '}
		  <Link color="text.secondary" href="https://www.tdbax.com/">
		    tdbax
		  </Link>
		  &nbsp;&copy;&nbsp;
		  {new Date().getFullYear()}
		</Typography>
		</React.Fragment>
	);
}

// Display text of what this website is build with.
function BuiltWithText() {
	return (
		<React.Fragment>
		<Typography variant="body2" color="text.secondary" align="left">
				Built with{' '}
		    <Link href="https://react.dev/" target="_blank" rel="noopener">
		    	React
		    </Link>
				{' '}and{' '}
		    <Link href="https://www.djangoproject.com/" target="_blank" rel="noopener">
		    	Django
		    </Link>
		    <br />Powered by{' '}
			<Link href='https://www.postgresql.org/' target='_blank' rel='noopener'>
				PostgreSQL
			</Link>
			,{' '}
		    <Link href="https://www.nginx.com/" target="_blank" rel="noopener">
		    	nginx
		    </Link>
			,{' '}and{' '}
			<Link href='https://www.freebsd.org/' target='_blank' rel='noopener'>
				FreeBSD
			</Link>
		</Typography>
		</React.Fragment>
	);
}

// Display images of what this website is built with, with an optionally
// specified size.
function BuiltWithImage({size = 25}) {
	return (
		<React.Fragment>
		<Link
			color='inherit'
			href='https://react.dev/'
			aria-label='React'
			sx={{ alignSelf: 'center', textDecoration: 'none' }}
		>
		<img
			src={`${env.DOMAIN}/static/img/madewithreactjs.png`}
			alt='Built with React'
			style={{ width: 'auto', height: `${size}px` }}
			/>
		</Link>
		
		<Link
			color='inherit'
			href='https://www.djangoproject.com/'
			aria-label='Django'
			sx={{ alignSelf: 'center', textDecoration: 'none' }}
		>
		<img
			src={`${env.DOMAIN}/static/img/django-logo-negative.png`}
			alt='Built with Django'
			style={{ width: 'auto', height: `${size}px` }}
			/>
		</Link>
		
		<Link
			color='inherit'
			href='https://www.nginx.org/'
			aria-label='nginx'
			sx={{ alignSelf: 'center', textDecoration: 'none' }}
		>
		<img
			src={`${env.DOMAIN}/static/img/nginx.png`}
			alt='Powered by nginx'
			style={{ width: 'auto', height: `${size}px` }}
			/>
		</Link>
		<Link
			color='inherit'
			href='https://www.freebsd.org/'
			aria-label='FreeBSD'
			underline='none'
			sx={{ alignSelf: 'center' }}
		>
		<img
			src={`${env.DOMAIN}/static/img/FREEBSD_Logo_Horiz_Neg_RGB.png`}
			alt='Powered by FreeBSD'
			style={{ width: 'auto', height: `${size}px` }}
			/>
		</Link>
		</React.Fragment>
	);
}

function PoweredByFreeBSD({size = 25, img = freebsdImg}) {
	return (
		<React.Fragment>
		<ThemeProvider theme={theme}>
		<Link
			color='inherit'
			href='https://www.freebsd.org/'
			aria-label='FreeBSD'
			underline='none'
			sx={{ alignSelf: 'center' }}
		>
		<img
			src={`${env.DOMAIN}/static/img/${img}`}
			alt='Powered by FreeBSD'
			style={{ width: 'auto', height: `${size}px` }}
			/>
		</Link>
		</ThemeProvider>
		</React.Fragment>
	);
}

export default function Footer() {
  return (
	<React.Fragment>
    <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          textAlign: { sm: 'center', md: 'left' },
        }}
    >

    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        pt: { xs: 4, sm: 8 },
        width: '100%',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
		<Stack
			sx={{ width: '50%' }}>
			<Copyright />
			<Quote />
		</Stack>
		<Stack
		  direction="row"
		  spacing={2}
		  useFlexGap
		  sx={{ width: '50%', justifyContent: 'center', alignItems: 'center', color: 'text.secondary' }}
		>
			<BuiltWithText />
			<PoweredByFreeBSD />
		</Stack>

    </Box>
    </Container>
    </React.Fragment>
  );
}
